import React from "react";
import GroupCreateForm from "./GroupCreateForm";

export default function GroupCreatePage({ controller, t }) {
  return (
    <div className="groups-create-page">
      <div className="groups-create-page-header">
        <button
          type="button"
          className="groups-create-page-close"
          onClick={controller.closeCreateForm}
          aria-label={t("close")}
        >
          {'\u2715'}
        </button>
      </div>
      <div className="groups-create-page-content">
        <GroupCreateForm controller={controller} t={t} />
      </div>
    </div>
  );
}
